import {
  QueryExpressionFromJSON,
  QueryExpressionToJSON,
  SearchLogisticsObjectsRequest,
} from '@/api/bol';

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return !!value && typeof value === 'object' && !Array.isArray(value);
};

export const encodeSearchQueryForUrl = (
  searchQuery: SearchLogisticsObjectsRequest | undefined,
): string | null => {
  if (!isRecord(searchQuery)) {
    return null;
  }

  const payload: Record<string, unknown> = {};

  if (searchQuery.query) {
    payload.query = QueryExpressionToJSON(searchQuery.query);
  }

  if (searchQuery.sort) {
    payload.sort = searchQuery.sort;
  }

  if (searchQuery.aggregations) {
    payload.aggregations = searchQuery.aggregations;
  }

  if (Object.keys(payload).length === 0) {
    return null;
  }

  try {
    return JSON.stringify(payload);
  } catch (error) {
    console.error('Failed to encode search query for URL:', error);
    return null;
  }
};

export const decodeSearchQueryFromUrl = (
  encodedSearchQuery: string | null,
): SearchLogisticsObjectsRequest | undefined => {
  if (!encodedSearchQuery) {
    return undefined;
  }

  try {
    const parsedPayload = JSON.parse(encodedSearchQuery) as unknown;

    if (!isRecord(parsedPayload)) {
      return undefined;
    }

    const parsedQuery = parsedPayload.query;
    const parsedSort = parsedPayload.sort;
    const parsedAggregations = parsedPayload.aggregations;

    const decoded: SearchLogisticsObjectsRequest = {};

    if (parsedQuery && isRecord(parsedQuery)) {
      decoded.query = QueryExpressionFromJSON(parsedQuery);
    }

    if (Array.isArray(parsedSort)) {
      decoded.sort = parsedSort as SearchLogisticsObjectsRequest['sort'];
    }

    if (parsedAggregations !== undefined) {
      decoded.aggregations = parsedAggregations as SearchLogisticsObjectsRequest['aggregations'];
    }

    return Object.keys(decoded).length > 0 ? decoded : undefined;
  } catch (error) {
    console.error('Failed to decode search query from URL:', error);
    return undefined;
  }
};
